const bundledImages = new Set([
  ...[
    'DR-landing-page-02-c-resized.jpeg', 'DR-landing-page-02-c.webp',
    'DR-landing-page-04-c-resized.jpeg', 'DR-landing-page-04-c.webp',
    'DR-landing-page-05-c-resized.jpeg', 'DR-landing-page-05-c.webp',
    'DR-landing-page-poster.webp', 'logo-footer.png', 'logo-header.webp',
    'shop-drc.webp', 'tennis-drc.webp',
  ].map((name) => `/landing-pages/drc/images/${name}`),
  ...[
    'dusk.webp', 'studio-map.webp', 'turki-square-1.webp', 'turki-square-2.webp', 'turki-square-3.webp', 'turki-square-4.webp',
    'hero.webp', 'origins.webp', 'benefits.webp', 'ashley-garcia.webp',
    'what-is-the-pilates-powerhouse.webp',
    'pilates-for-every-age.webp',
    'meet-the-cadillac.webp',
    '10-minute-pilates-for-beginners.webp',
    'the-hundred.webp',
    'the-roll-up.webp',
    'rolling-like-a-ball.webp',
    'double-leg-stretch.webp',
    'spine-stretch-forward.webp',
    'the-saw.webp',
    'open-leg-rocker.webp',
    'the-swan.webp',
    'the-teaser.webp',
    'side-kick-series.webp',
  ].map((name) => `/landing-pages/kavette/images/${name}`),
  ...[
    'about-us-athlete-poster.webp', 'about-us-racket-flatlay.webp', 'about-us-volleyball-rally.webp',
    'ac-milan-hero-wide.webp', 'ac-milan-lockup-v.webp', 'ac-milan-pitch.webp',
    'academies-basketball-video-poster.webp', 'academies-climbing-video-poster.webp',
    'academies-loop-poster.webp', 'academies-tennis-video-poster.webp', 'academies-volleyball-video-poster.webp',
    'court-rentals-courts-poster.webp', 'facility-basketball-dunk.webp', 'facility-basketball-poster.webp',
    'facility-football-court.webp', 'facility-football-poster.webp', 'facility-gym-poster.webp',
    'facility-padel-swing.webp', 'facility-tennis-serve.webp', 'facility-track-poster.webp',
    'facility-treadmills.webp', 'facility-volleyball-spike.webp', 'home-academies-field.webp',
    'home-hero-poster-land-1920.webp', 'sportplex-logo.webp',
  ].map((name) => `/landing-pages/sportplex/images/${name}`),
  ...[
    'about-section.webp', 'gym.webp', 'hero-court.webp', 'logo-header.webp',
    'padel-court.webp', 'tennis-court.webp', 'trs-logo.webp',
  ].map((name) => `/landing-pages/trs/images/${name}`),
  ...[
    'about.jpg', 'award-prestige.png', 'bg-mandala-circle.png', 'boutique.jpg',
    'class-full-moon.png', 'class-kym.jpg', 'class-new-moon.jpeg', 'class-nidra.jpg',
    'class-sweaty-arms.png', 'class-sweaty-core.png', 'class-sweaty-flow.png',
    'class-sweaty-legs.jpg', 'class-warrior.jpg', 'cls-aerial-stretch.jpg',
    'cls-aerial-yoga.jpg', 'cls-ashtanga.jpg', 'cls-candlelight.jpg', 'cls-karama-mama.jpg',
    'cls-mobility.jpg', 'cls-power-pilates.jpg', 'cls-sculpt-flow.jpg',
    'cls-stress-release.jpg', 'cls-sweaty-core.jpg', 'cls-sweaty-warrior.jpg',
    'cls-yoga-sculpt.jpg', 'exterior-new.jpg', 'exterior.jpg', 'founder.jpg',
    'founder2.jpg', 'hero-indoor-outdoor.png', 'hero-mandala.png', 'hero-mat-shots.png',
    'hero-mudra.jpg', 'hero-studio-entrance.jpg', 'hero-studio-logo.jpg',
    'hero-studio-mats.jpg', 'hero-studio-wall.jpg', 'lana-bench.jpg',
    'lana-boutique-pink.jpg', 'lana-circle.png', 'lana-dress.jpg', 'lana-portrait.jpg',
    'logo-stacked-full.png', 'logo-stacked.png', 'logo-white-text.png', 'logo.png',
    'studio-interior.jpg', 'studio-wall.jpg', 'testimonial-eman.png', 'testimonial-rasha.png',
  ].map((name) => `/landing-pages/karama/images/${name}`),
]);

export function isBundledLandingImage(value: string) {
  return bundledImages.has(value);
}

const bundledVideos: Record<string, readonly string[]> = {
  drc: ['/landing-pages/drc/images/DRC_Landing_page_compressed.mp4'],
};

export function getBundledLandingVideos(subdomain: string | undefined) {
  return subdomain && Object.hasOwn(bundledVideos, subdomain) ? bundledVideos[subdomain]! : [];
}

export function isBundledLandingVideo(value: string) {
  return Object.values(bundledVideos).some((keys) => keys.includes(value));
}
